import AiGenerativeTextSummaryIcon from '@atlaskit/icon/core/ai-generative-text-summary';
import * as React from 'react';

export function SvgAutoSummaries() {
  return <AiGenerativeTextSummaryIcon label="" testId="ads-refreshed-icon" />;
}
